<template>
  <div class="calendar-container">
    <div v-if="calendarLoading" class="loading-container">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else class="table-responsive">
      <table>
        <thead>
          <tr>
            <th class="text-center">Ngày</th>
            <th class="text-start">Học phần</th>
            <th class="text-start d-none d-sm-table-cell">Lớp học</th>
            <th class="text-end d-none d-md-table-cell">Bắt đầu</th>
            <th class="text-end d-none d-md-table-cell">Kết thúc</th>
            <th class="text-start" v-if="!isHideAttendance">Điểm danh</th>
          </tr>
        </thead>
        <tbody v-for="(dayData, day) in daysOfWeek" :key="day">
          <tr v-if="dayData.lessons.length">
            <td class="date-cell" :rowspan="dayData.lessons.length + 1">
              <div class="day-name">{{ dayNames[day] }}</div>
              <div class="date">{{ moment(dayData.date).format('DD/MM/YYYY') }}</div>
            </td>
          </tr>
          <tr v-for="(lesson, index) in dayData.lessons" :key="index">
            <td class="lesson-cell">
              {{ `${get(lesson, 'grade.code')} - ${get(lesson, 'grade.title')}` }}
            </td>
            <td class="class-cell d-none d-sm-table-cell">{{ lesson.classTitle }}</td>
            <td class="time-cell d-none d-md-table-cell text-end">{{ lesson.startTime }}</td>
            <td class="time-cell d-none d-md-table-cell text-end">{{ lesson.endTime }}</td>
            <td class="attendance-cell" v-if="!isHideAttendance">
              <span :class="getAttendanceClass(lesson)">{{ getAttendance(lesson) }}</span>
            </td>
          </tr>
          <tr v-if="!dayData.lessons.length">
            <td class="date-cell">
              <div class="day-name">{{ dayNames[day] }}</div>
              <div class="date">{{ moment(dayData.date).format('DD/MM/YYYY') }}</div>
            </td>
            <td class="lesson-cell"></td>
            <td class="class-cell d-none d-sm-table-cell"></td>
            <td class="time-cell d-none d-md-table-cell"></td>
            <td class="time-cell d-none d-md-table-cell"></td>
            <td class="attendance-cell" v-if="!isHideAttendance"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import moment from 'moment'

export default {
  props: {
    calendarLoading: {
      type: Boolean,
      default: false,
    },
    isHideAttendance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dayNames: {
        monday: 'Thứ 2',
        tuesday: 'Thứ 3',
        wednesday: 'Thứ 4',
        thursday: 'Thứ 5',
        friday: 'Thứ 6',
        saturday: 'Thứ 7',
        sunday: 'Chủ nhật',
      },
      get,
      moment,
    }
  },
  computed: {
    ...mapState({
      daysOfWeek(state) {
        return state['lessonAttendance'].classLessons
      },
    }),
  },
  methods: {
    getAttendance(lesson) {
      if (!lesson.isAttended) return 'Chưa điểm danh'
      if (lesson.attendanceStatus === 'none') return 'Chưa điểm danh'
      if (lesson.attendanceStatus === 'attended') return 'Có mặt'
      if (lesson.attendanceStatus === 'absent') return 'Vắng mặt'
    },
    getAttendanceClass(lesson) {
      if (!lesson.isAttended || lesson.attendanceStatus === 'none') return 'status-pending'
      if (lesson.attendanceStatus === 'attended') return 'status-present'
      if (lesson.attendanceStatus === 'absent') return 'status-absent'
    },
  },
}
</script>

<style lang="scss" scoped>
.calendar-container {
  font-size: 14px;
  @media (min-width: 600px) {
    font-size: 16px;
  }
}

.loading-container {
  height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 500px;
}

td, th {
  border: 1px solid #ccc;
  padding: 8px;
  @media (max-width: 600px) {
    padding: 4px;
  }
}

.date-cell {
  width: 100px;
  text-align: center;
  @media (min-width: 600px) {
    width: 150px;
  }
}

.lesson-cell {
  min-width: 150px;
  @media (min-width: 600px) {
    min-width: 200px;
  }
}

.class-cell {
  min-width: 150px;
  @media (min-width: 600px) {
    min-width: 200px;
  }
}

.time-cell {
  min-width: 60px;
  @media (min-width: 600px) {
    min-width: 70px;
  }
}

.attendance-cell {
  min-width: 90px;
  @media (min-width: 600px) {
    min-width: 100px;
  }
}

.status-pending {
  color: rgba(0, 0, 0, 0.6);
}

.status-present {
  color: green;
}

.status-absent {
  color: red;
}

.day-name {
  font-weight: 500;
}

.date {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.9em;
}

// Utility classes
.d-none {
  display: none;
}

@media (min-width: 600px) {
  .d-sm-table-cell {
    display: table-cell;
  }
}

@media (min-width: 960px) {
  .d-md-table-cell {
    display: table-cell;
  }
}

.text-center {
  text-align: center;
}

.text-start {
  text-align: left;
}

.text-end {
  text-align: right;
}
</style>
